<template>
  <el-drawer
    class="wait-prescription-drawer"
    size="360px"
    :title="title"
    :visible="visible"
    direction="rtl"
    @close="$emit('close')"
  >
    <iframe :src="iframeSrc" style="width: 100%; height: 100%; border: none"></iframe>
    <slot v-bind="$attrs"></slot>
  </el-drawer>
</template>

<script>
export default {
  name: 'drawer',
  props: {
    title: {
      type: String,
      default: '待审核处方'
    },
    visible: {
      type: Boolean,
      default: false
    },
    prescription: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    iframeSrc() {
      const { prescription } = this;
      const host = Util.getItmOrigin();
      return `${host}project/internetDrugstore?login=true&autoInit=true#/prescriptionDesc/${prescription.id}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.wait-prescription-drawer {
  /deep/.el-drawer__header {
    display: flex;
    justify-content: center;
    padding: 0 24px;
    margin-bottom: unset;
    height: 56px;

    > span {
      font-size: 16px;
      font-weight: 500;
      color: #262626;
    }
  }

  /deep/.el-drawer__body {
    position: relative;
  }
}
</style>
